module.exports = __webpack_public_path__ + "img/2975.93e56193.png";